module.exports = "/assets/4221b96306fe36e77f2fc551beb5f4ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/J2.png
// module id = 1495
// module chunks = 0